import { PRODUCTS_PER_PAGE } from 'constant';

import { GetProductsByFilterParams, GetProductTypeListParams } from 'types';

import { del, get, post } from './axios';

const URLS = {
  getProductsByType: 'products/items',
  getProductById: 'products/item',
  toggleFavoriteState: 'products/set-fav',
  getBrands: 'products/brands',
  getCategories: 'products/categories',
  getPurchasedProducts: 'products/purchased'
};

const productsApi = {
  getProductsByType: (params: GetProductTypeListParams) =>
    post(URLS.getProductsByType, params),
  getProductById: (productId: number) =>
    get(`${URLS.getProductById}/${productId}`, { pr_id: productId }),
  addProductToFavorite: (productId: number) =>
    post(URLS.toggleFavoriteState, { prid: productId }),
  deleteProductFromFavorite: (productId: number) =>
    del(URLS.toggleFavoriteState, { prid: productId }),
  getBrands: () => get(URLS.getBrands),
  getCategories: () => get(URLS.getCategories),
  getProductsByFilter: (params: GetProductsByFilterParams) =>
    get(URLS.getProductsByType, { ...params, items: PRODUCTS_PER_PAGE }),
  getPurchasedProducts: () => get(URLS.getPurchasedProducts)
};

export default productsApi;
